import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { url: String }

  connect() {
    this.draggedItem = null
  }

  itemTargetConnected(item) {
    item.setAttribute("draggable", "true")
    item.addEventListener("dragstart", this.handleDragStart)
    item.addEventListener("dragend", this.handleDragEnd)
    item.addEventListener("dragover", this.handleDragOver)
    item.addEventListener("drop", this.handleDrop)
    item.addEventListener("dragenter", this.handleDragEnter)
    item.addEventListener("dragleave", this.handleDragLeave)
  }

  itemTargetDisconnected(item) {
    item.removeEventListener("dragstart", this.handleDragStart)
    item.removeEventListener("dragend", this.handleDragEnd)
    item.removeEventListener("dragover", this.handleDragOver)
    item.removeEventListener("drop", this.handleDrop)
    item.removeEventListener("dragenter", this.handleDragEnter)
    item.removeEventListener("dragleave", this.handleDragLeave)
  }

  handleDragStart = (event) => {
    this.draggedItem = event.target.closest("[data-notes-sortable-target='item']")
    this.draggedItem.classList.add("dragging")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.draggedItem.id)
    event.dataTransfer.setData("application/x-note", this.draggedItem.id)
  }

  handleDragEnd = () => {
    if (this.draggedItem) {
      this.draggedItem.classList.remove("dragging")
    }
    this.clearDragStyles()
    this.draggedItem = null
  }

  handleDragOver = (event) => {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.target.closest("[data-notes-sortable-target='item']")
    if (!target || target === this.draggedItem) return

    const rect = target.getBoundingClientRect()
    const midpoint = rect.top + rect.height / 2

    this.clearDragStyles()
    if (event.clientY < midpoint) {
      target.classList.add("drag-over-top")
    } else {
      target.classList.add("drag-over-bottom")
    }
  }

  handleDragEnter = (event) => {
    event.preventDefault()
  }

  handleDragLeave = (event) => {
    const target = event.target.closest("[data-notes-sortable-target='item']")
    if (target && !target.contains(event.relatedTarget)) {
      target.classList.remove("drag-over-top", "drag-over-bottom")
    }
  }

  handleDrop = (event) => {
    event.preventDefault()

    const target = event.target.closest("[data-notes-sortable-target='item']")
    if (!target || !this.draggedItem || target === this.draggedItem) return

    const rect = target.getBoundingClientRect()
    const midpoint = rect.top + rect.height / 2

    if (event.clientY < midpoint) {
      target.parentNode.insertBefore(this.draggedItem, target)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    }

    this.clearDragStyles()
    this.saveOrder()
  }

  clearDragStyles() {
    this.itemTargets.forEach(item => {
      item.classList.remove("drag-over-top", "drag-over-bottom")
    })
  }

  saveOrder() {
    const noteIds = this.itemTargets.map(item => {
      // Get note ID from data attribute or dom_id format
      return item.dataset.noteId || item.id.match(/note_(\d+)/)?.[1]
    }).filter(id => id !== null)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ note_ids: noteIds })
    }).catch(error => {
      console.error("Reorder failed:", error)
    })
  }
}
